module.exports = __webpack_public_path__ + "static/media/LogoImg.754d5968.png";